import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';
import { rankWith, uiTypeIs, isLayout } from '@jsonforms/core';
import { withJsonFormsLayoutProps, JsonFormsDispatch } from '@jsonforms/react';
import styled, { css } from 'styled-components';

var gapOptions = {
    medium: 22,
};

var JsonFormsHorizontalLayoutBase = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  section {\n    flex-grow: 1;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  section {\n    flex-grow: 1;\n  }\n\n  ", "\n"])), function (_a) {
    var _b = _a.gapNumber, gapNumber = _b === void 0 ? gapOptions.medium : _b;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      gap: ", "px;\n    "], ["\n      gap: ", "px;\n    "])), gapNumber);
});
var templateObject_1, templateObject_2;

var jsonFormsHorizontalLayoutTester = rankWith(3, uiTypeIs('HorizontalLayout'));
var JsonFormsHorizontalLayout = withJsonFormsLayoutProps(function (_a) {
    var _b;
    var cells = _a.cells, enabled = _a.enabled, path = _a.path, renderers = _a.renderers, schema = _a.schema, uischema = _a.uischema, visible = _a.visible;
    if (!visible || !isLayout(uischema)) {
        return null;
    }
    var gap = (_b = uischema.options) === null || _b === void 0 ? void 0 : _b.gap;
    var gapNumber = gapOptions[gap];
    return (jsx(JsonFormsHorizontalLayoutBase, __assign({ gapNumber: gapNumber }, { children: uischema.elements.map(function (child, index) {
            return (jsx(JsonFormsDispatch, { cells: cells, enabled: enabled, path: path, renderers: renderers, schema: schema, uischema: child }, index));
        }) }), void 0));
});

export { JsonFormsHorizontalLayout as J, jsonFormsHorizontalLayoutTester as j };
